export default __webpack_public_path__ + "static/media/NoImage.519f4d43.svg";